import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Pagination from '../common/Pagination'
import PropTypes from 'prop-types'
import moment from 'moment'

import { ReactComponent as EllipsisIcon } from '../../assets/images/common/icons/ellipsis-icon.svg'
import { UncontrolledPopover } from 'reactstrap'
import '../../assets/styles/components/communities/CommunitiesTable.scss'
import { Link, useNavigate } from 'react-router-dom'
import { ReactComponent as StripeIcon } from '../../assets/images/common/icons/stripe-icon.svg'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import { licenseLabel } from '../../utility/communityLicense'
import OrganizationChips from '../common/OrganizationChips'

const CommunitiesTable = ( { fetchCommunities, toggleCommunity, toggleConfirmationModal, loader, page } ) => {
  const { t } = useTranslation()
  const pages = useSelector(state => state.pages)
  const communities = useSelector(state => state.communities.communities)
  const navigate = useNavigate()

  const renderCommunitiesTable = () => (
    <table className='table w-100 animated fadeIn'>
      <thead className='primary-background'>
        <tr>
          <th className='font-200'>{t('communities.table.id')}</th>
          <th className='font-200'>{t('common.field.name')}</th>
          <th className='font-200'>{t('communities.common.licenseType')}</th>
          <th className='font-200'>{t('communities.table.state')}</th>
          <th className='font-200'>{t('communities.table.createdDate')}</th>
          <th className='font-200'>{t('communities.common.accountManager')}</th>
          <th className='font-200'>{t('communities.table.landingPage')}</th>
          <th className='font-200'>{t('communities.table.activeClasses')}</th>
          <th className='font-200'>{t('communities.table.enrollments')}</th>
          <th className='font-200'>{t('communities.table.coachName')}</th>
          <th className='font-200'>{t('communities.table.organizations')}</th>
          <th className='font-200'>Stripe</th>
          <th></th>
        </tr>
      </thead>
      <tbody>{renderCommunities()}</tbody>
    </table>
  )

  const renderCommunities = () => {
    if (communities.length === 0) {
      return null
    } else {
      return communities.map((community) =>
        renderCommunityRow(community)
      )
    }
  }

  const showCommunityImage = (community) => {
    if (community.photo) {
      return (
        <img
          src={community.photo.smallFileUrl}
          alt={community.name}
          className='img-responsive classDetailPage-avatar center-block'
        />
      )
    } else {
      return null
    }
  }

  const renderCommunityRow = (community) => (
    <tr
      key={community.id}
      className={`border-bottom ${!community.isActive && 'community-row'}`}
    >
      <td>{community.id}</td>
      <td>{showCommunityImage(community)} {community.name}</td>
      <td>{licenseLabel(community.licenseType) ? t(licenseLabel(community.licenseType)) : t('communities.table.noLicense')}</td>
      <td>{community.address.state ? community.address.state : t('communities.table.noState')}</td>
      <td>{moment(community.createdAt).format('M/D/Y')}</td>
      <td>{community.representativeName ? community.representativeName : t('communities.table.noManager')}</td>
      <td>
        <Link to={`/landing/${community.id}`} target='_blank'>
          {t('communities.table.clickHere')}
        </Link>
      </td>
      <td>{community.activeClasses}</td>
      <td>{community.enrollmentsCount}</td>
      <td>{community.leadCoach ? community.leadCoach.firstName + ' ' + community.leadCoach.lastName : t('communities.table.noCoach')}</td>
      <td><OrganizationChips organizations={community.organizations} emptyLabel={t('communities.table.noOrganization')} /></td>
      <td>{community.selectedStripeConnectedAccount ? <StripeIcon id='stripeIcon' /> : t('communities.table.noAccount')}</td>
      <td className='table-row-actions' style={{ width: '5%' }}>
        <EllipsisIcon id={`community_${community.id}`} className='table-ellipsis'/>
        <UncontrolledPopover
          placement='bottom'
          target={`community_${community.id}`}
          trigger='legacy'
          popperClassName='popover-style'
        >
          <div className='communities-actions d-flex flex-column align-items-start justify-content-start'>
            <button className='community-action' onClick={() => navigate(`/communities/${community.id}`)}>
              {t('communities.table.review')}
            </button>
            <button className='community-action' onClick={() => toggleConfirmationModal(community)}>
              {t('communities.common.login')}
            </button>
            <a
              href={`https://app.hubspot.com/contacts/44706418/record/2-27564788/${community.hubspotOnboardingId}`}
              target='_blank'
              className={`community-action ${community.hubspotOnboardingId ? '' : 'disabled'}`}
            >
              {community.hubspotOnboardingId ? 'HubSpot' : t('communities.table.noHubspot')}
            </a>
            <button className='community-action' onClick={() => toggleCommunity(community)}>
              {community.isActive ? t('communities.table.deactivate') : t('communities.table.activate')}
            </button>
          </div>
        </UncontrolledPopover>
      </td>
    </tr>
  )

  return (
    <div>
      {pages > 1 && (
        <Pagination
          pageCount={pages}
          fetchData={fetchCommunities}
          activePage={page}
        />
      )}

      { loader
        ? ( <Loader message={t('communities.table.loadingCommunities')} /> )
        : communities && communities.length > 0
          ? renderCommunitiesTable()
          : (
            <div className='no-packages d-flex justify-content-center'>
              <p className='mb-0'>{t('communities.table.noAvailableCommunities')}</p>
            </div>
          )
      }
    </div>

  )
}

CommunitiesTable.propTypes = {
  fetchCommunities: PropTypes.func,
  loader: PropTypes.bool,
  page: PropTypes.number,
  toggleCommunity: PropTypes.func,
  toggleConfirmationModal: PropTypes.func,
}

export default CommunitiesTable
